import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ILoginEvent, ITokens } from "@gloria-public/login/domain/interfaces/login.interface";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ConnectionEventsService {
  /** Emits after a successful login with the new authentication data. */
  private loginSubject = new Subject<ILoginEvent>();
  /** Emits when the user logs out. */
  private logoutSubject = new Subject<void>();

  login$ = this.loginSubject.asObservable();
  logout$ = this.logoutSubject.asObservable();

  constructor(private router: Router) {}

  /**
   * Broadcasts a successful login.
   *
   * Triggers application-wide login side effects such as updating the session,
   * and reinitializing the cart.
   *
   * @param token Newly issued access and refresh tokens.
   * @param language User language associated with the authenticated session.
   */
  notifyLogin(token: ITokens, language: string): void {
    this.loginSubject.next({
      ...token,
      language,
    });
  }

  /**
   * Broadcasts a logout event and redirects to the login page.
   *
   * Triggers application-wide logout side effects such as clearing the session,
   * cancelling pending verification/consent flows, and reinitializing the cart.
   *
   * @param title Optional translation key displayed on the login page.
   */
  notifyLogout(title?: string): void {
    this.logoutSubject.next();
    if (title) {
      this.router.navigate(["/login"], { state: { title: title } });
    } else {
      this.router.navigate(["/login"]);
    }
  }
}
